export function getConfig(mode) {
    return {
        scriptSrc:
            mode === 'staging'
                ? 'https://cdn1-sandbox.affirm.com/js/v2/affirm.js'
                : 'https://cdn1.affirm.com/js/v2/affirm.js',
    }
}
